import {getRequest, postRequest} from "@/services/networkService.js";
import {getContext} from "./context.js";
import {getCachedApp, setCachedApp} from "./cacheService.js";

export async function CreateApp(context, name, platform) {
    let response = await postRequest(
        'apps',
        {
            name: name,
            platform: platform
        },
        context
    );

    if (response.ok) {
        return await response.json();
    } else {
        throw new Error('Failed to create app');
    }
}

export async function GetApps(context) {
    let response = await getRequest('apps', context);

    if (response.ok) {
        return await response.json();
    } else {
        throw new Error('Failed to get apps');
    }
}

export async function DeleteApp(context) {
    let response = await postRequest(
        `apps/${context.appId}/delete`,
        {},
        context
    );

    if (!response.ok) {
        throw new Error('Failed to delete app');
    }
}

export async function GetApp(context) {
    // Try to get from cache first
    const cached = getCachedApp(context.organisationId, context.appId);
    if (cached) {
        return cached;
    }

    // If not in cache, fetch from API
    let response = await getRequest(`apps/${context.appId}`, context);

    if (response.ok) {
        const data = await response.json();
        // Store in cache
        setCachedApp(context.organisationId, context.appId, data);
        return data;
    } else {
        throw new Error('Failed to fetch app');
    }
}

export async function GetAppAnalytics(context, startDate, endDate) {
    const params = new URLSearchParams({
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString()
    });

    let response = await getRequest(`analytics/${context.appId}?${params.toString()}`, context);

    if (!response.ok) {
        throw new Error('Failed to fetch app analytics');
    }

    return await response.json();
}